import { convertDateUnitType, DateUnitType } from '@/coreDomainsModule/date';
import { IOrderBasisAdjustment } from '@/coreDomainsModule/entities/orderBasis';
import { OrderBasisAdjustedInfo } from '@/coreInfrastructureModule/axios/generated/orderManage';

/**
 * 発注根拠で使用する単位
 */
type OrderBasisUnit = Exclude<DateUnitType, 'unknown'>;

/**
 * 発注根拠のユーザー操作項目アダプタ
 */
export class OrderBasisUserAdjustedAdapter {
  /**
   * 発注確定時にユーザーが操作した情報をリクエスト型に押し込む
   * @param adjustment - 発注確定時にユーザーが操作した情報
   * @returns - リクエスト型
   */
  public static adapt(adjustment: IOrderBasisAdjustment): OrderBasisAdjustedInfo {
    return {
      userAdjustedLeadTime: adjustment.leadTime?.value,
      userAdjustedLeadTimeUnit: adjustment.leadTime ? this.toOrderBasisUnit(adjustment.leadTime?.unit) : undefined,
      userAdjustedStdInventoryIndexMin: adjustment.stdInventoryIndex?.min,
      userAdjustedStdInventoryIndexMax: adjustment.stdInventoryIndex?.max,
      userAdjustedStdInventoryIndexUnit: adjustment.stdInventoryIndex
        ? this.toOrderBasisUnit(adjustment.stdInventoryIndex?.option.unit)
        : undefined,
      userAdjustedCustomerForecasts: adjustment.customerForecasts?.map((forecast) => ({
        targetYear: forecast.year,
        targetMonth: forecast.month,
        amount: forecast.amount.toFixed(6),
      })),
    };
  }

  /**
   * 単位を保証された単位に変換する
   * @param unit - 変換前単位
   * @returns - 変換された単位
   */
  private static toOrderBasisUnit = (unit: string): OrderBasisUnit => {
    const converted = convertDateUnitType(unit);

    if (converted === 'unknown') {
      throw new Error(`Unsupported date unit: ${unit}`);
    }

    return converted;
  };
}
